(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-campaign-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-camp-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var done = function () {
          var orig = btn.textContent;
          btn.textContent = btn.getAttribute('data-copied') || 'Kopiert';
          setTimeout(function () {
            btn.textContent = orig;
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
          } catch (e) {
            /* noop */
          }
          document.body.removeChild(ta);
          done();
        }
      });
    });

    document.querySelectorAll('[data-camp-countdown]').forEach(function (cd) {
      var end = new Date(cd.getAttribute('data-end')).getTime();
      var f = {
        days: cd.querySelector('[data-cd="days"]'),
        hours: cd.querySelector('[data-cd="hours"]'),
        minutes: cd.querySelector('[data-cd="minutes"]'),
        seconds: cd.querySelector('[data-cd="seconds"]'),
      };
      var pad = function (n) {
        return (n < 10 ? '0' : '') + n;
      };
      var timer = null;
      var tick = function () {
        var diff = end - Date.now();
        if (isNaN(end) || diff <= 0) {
          // Kampagne ist waehrend der Sitzung abgelaufen: Karte weg statt 00:00:00:00.
          var card = cd.closest('.tp-camp-hero');
          if (card) card.remove();
          if (timer) clearInterval(timer);
          return;
        }
        f.days.textContent = pad(Math.floor(diff / 86400000));
        f.hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        f.minutes.textContent = pad(Math.floor((diff % 3600000) / 60000));
        f.seconds.textContent = pad(Math.floor((diff % 60000) / 1000));
      };
      tick();
      timer = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-ecom-team"] && !Shopify.designMode) return;
  try {
    
  // <tp-vcard-button> — eigenständiges Web Component (self-init/self-cleanup, kein Sections.js).
  // Baut beim Klick/Enter aus den data-Attributen eine .vcf-Visitenkarte und lädt sie herunter.
  class TpVcardButton extends HTMLElement {
    constructor() {
      super();
      this._onActivate = this._onActivate.bind(this);
      this._onKey = this._onKey.bind(this);
    }

    connectedCallback() {
      if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
      this.addEventListener('click', this._onActivate);
      this.addEventListener('keydown', this._onKey);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onActivate);
      this.removeEventListener('keydown', this._onKey);
    }

    _onActivate() {
      this._download();
    }

    _onKey(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this._download();
      }
    }

    _esc(s) {
      return (s || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
    }

    _build() {
      const d = this.dataset;
      const name = d.name || '';
      const parts = name.split(' ');
      const last = parts.length > 1 ? parts.pop() : '';
      const first = parts.join(' ');
      const lines = ['BEGIN:VCARD', 'VERSION:3.0',
        'N:' + this._esc(last) + ';' + this._esc(first) + ';;;',
        'FN:' + this._esc(name),
        'ORG:' + this._esc(d.org || 'Talk-Point GmbH')];
      if (d.role) lines.push('TITLE:' + this._esc(d.role));
      if (d.email) lines.push('EMAIL;TYPE=WORK:' + d.email);
      if (d.phone) lines.push('TEL;TYPE=WORK,VOICE:' + d.phone);
      lines.push('URL:https://talk-point.de');
      lines.push('END:VCARD');
      return lines.join('\r\n');
    }

    _download() {
      try {
        const v = this._build();
        const fname = (this.dataset.name || 'kontakt').replace(/\s+/g, '_') + '.vcf';
        const blob = new Blob([v], { type: 'text/vcard;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fname;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
      } catch (e) {
        try {
          window.location.href = 'data:text/vcard;charset=utf-8,' + encodeURIComponent(this._build());
        } catch (err) {
          console.error('vCard download failed', err);
        }
      }
    }
  }

  if (!customElements.get('tp-vcard-button')) {
    customElements.define('tp-vcard-button', TpVcardButton);
  }

  } catch(e) { console.error(e); }
})();
})();
